'use strict';

require('../../style/index.less');

require('../../popover/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/popconfirm/style/index.tsx
 ** module id = 342
 ** module chunks = 0
 **/